module.exports = __webpack_public_path__ + "static/img/TLAppLogo_White.73c925e3.svg";